import type { DropdownMenuItemProps, ItemProps } from '../../../../core'
import { DropdownMenuItem, Item, Keyboard } from '../../../../core'
import { GlobalHotkeys } from '../../../utils/hotkeys'

export interface LeaveFeedbackDropdownMenuItemProps extends Omit<
  DropdownMenuItemProps,
  'children' | 'disabled' | 'icon'
> {
  onLeaveFeedback: () => void
}

export function LeaveFeedbackDropdownMenuItem({
  onLeaveFeedback,
  ...props
}: LeaveFeedbackDropdownMenuItemProps) {
  return (
    <DropdownMenuItem
      shouldCloseOnSelect={false}
      endAdornment={<Keyboard>{GlobalHotkeys.leaveFeedback}</Keyboard>}
      {...props}
      onSelect={(event) => {
        event.preventDefault()
        props.onSelect?.(event)
        onLeaveFeedback()
      }}
    >
      {`Leave feedback…`}
    </DropdownMenuItem>
  )
}

export interface LeaveFeedbackItemProps extends Omit<ItemProps, 'asChild'> {
  onLeaveFeedback: () => void
}

export function LeaveFeedbackItem({
  onLeaveFeedback,
  ...props
}: LeaveFeedbackItemProps) {
  return (
    <Item
      isInteractive
      {...props}
      onClick={(event) => {
        props.onClick?.(event)
        if (event.defaultPrevented === false) {
          onLeaveFeedback()
        }
      }}
    >
      {`Leave feedback`}
    </Item>
  )
}
